export default __webpack_public_path__ + "static/ActaHeadline-BookItalic-c49a07d3fbc55cbff2060a47eeeafb93.woff2";